import * as THREE from 'three';

export default class CSSUX {

    constructor(config) {

        let self = this;
        let defaultConfig = {};

        this.config = deepmerge(defaultConfig, config);

        document.addEventListener("timeline_loaded", this.inits.bind(this));

        this.enabled = false;
        this.cssux_col = document.querySelectorAll('[data-cssux]');
        this.tempV = new THREE.Vector3();
        this.elems = [];

    }

    inits(){
        this.enabled=true;
        document.removeEventListener("timeline_loaded", this.inits);
    }

    update(){

        if(this.enabled) {
            for (let cssux_el of this.cssux_col) {

                let threeobj = window.timeline.scene.getObjectByName(cssux_el.dataset.cssux);
                if(threeobj) {
                    threeobj.updateWorldMatrix(true, false);
                    threeobj.getWorldPosition(this.tempV);
                    this.tempV.project(window.timeline.cameramanager.camera);

                    let x = ((this.tempV.x * .5 + .5) * window.timeline.renderer.domElement.clientWidth);
                    let y = ((this.tempV.y * -.5 + .5) * window.timeline.renderer.domElement.clientHeight);

                    cssux_el.style.transform = `translate(-50%, -50%) translate(${x}px,${y}px)`;
                }

            }
        }
    }

    blueprintLoaded(){

    }

    /**
     * @param conf {html_element: el, object_name: string}
     */
    registerUXElem(conf){
        this.elems.push(conf);
    }

    /**
     * @param conf {html_element: el, object_name: string}
     */
    unRegisterUXElem(conftoremove){
        this.elems = this.elems.filter(function(el) {
            return el !== conftoremove
        })
    }


}






